import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpClientModule, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { NgbActiveModal, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {NgxAngularQueryBuilderModule} from 'ngx-angular-query-builder';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ColorPickerModule } from 'ngx-color-picker';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { QuillConfigModule, QuillModule } from 'ngx-quill';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { ResizableModule } from 'projects/Autofacets-Core/src/app/directives/af-Resizable';
import { environment } from '../environments/environment';
import { CurrentLanguage } from '../../../Autofacets-Core/src/app/common-services/current-language.service';
import { ExcelService } from '../../../Autofacets-Core/src/app/common-services/export-excel.service';
import { LanguageDataService } from '../../../Autofacets-Core/src/app/common-services/language-data.service';
import { SafePipe } from '../app/pipe/img-safe.pipe';
import { WorkItemLinkPipe } from '../app/pipe/work-item-link.pipe';
import { AutofacetsCoreModule } from './../../../Autofacets-Core/src/app/app.module';
import { CustomLoader } from './../../../Autofacets-Core/src/app/common-services/custom-loader.service';
import { FileSizePipe } from './../../../Autofacets-Core/src/app/pipes/filesize/filesize';
import { NgbdModalContent } from './../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { AppIntializer } from './app-intializer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DealerHolidayBusinessService } from './business-services/dealer-holiday.service';
import { DealerServiceBusinessService } from './business-services/dealer-service.service';
import { DealerBusinessService } from './business-services/dealer.service';
import { StatusconfigurationService } from './business-services/status-configuration.service';
import { VehicleBusinessService } from './business-services/vehicle-service';
import { AfMechanicSchedulerListComponent } from './components/af-mechanic-scheduler-list/af-mechanic-scheduler-list.component';
import { SchedulerDayViewComponent } from './components/af-scheduler-day-view/scheduler-day-view.component';
import { SchedulerListComponent } from './components/af-scheduler-list/scheduler-list.component';
import { DealerSearchboxDropdownComponent } from './components/dealer-searchbox-dropdown/dealer-searchbox-dropdown/dealer-searchbox-dropdown.component'; // Added By Bhavesh 06 aug 2021
import { DealerSearchboxComponent } from './components/dealer-searchbox/dealer-searchbox.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SavedSearchComponent } from './components/saved-search/saved-search.component';
import { ServiceAdvisorComponent } from './components/service-advisor/service-advisor.component';
import { ServiceDurationPriceComponent } from './components/service-duration-price/service-duration-price.component';
import { DealerDataService } from './data-services/dealer-data.service';
import { DealerHolidayDataService } from './data-services/dealer-holiday-data.service';
import { DealerServiceDataService } from './data-services/dealer-service-data.service';
import { StatusconfigurationDataService } from './data-services/status-configuration-data.service';
import { VehicleDataService } from './data-services/vehicle-data.service';
import { UpdateAppointmentHistoryPipe } from './pipe/appointment-history.pipe';
import { CurrencySpacePipe } from './pipe/currency-space.pipe';
import { MechanicSlotFilterPipe } from './pipe/mechanic-pipe/mechanicSlotFilter.pipe';
import { StringToJobDetailsTablePipe } from './pipe/stringtojobdeatis.pipe';
import { StringToPlanningTablePipe } from './pipe/stringtoplanning.pipe';
import { StringToTablePipe } from './pipe/stringtotable.pipe';
import { ToNumberPipe } from './pipe/toNumber.pipe';
import { PaginationService } from './services/pagination.service';
import { AdminCommonService } from './services/admin-common.service'
import { AccountsComponent } from './views/accounts/accounts.component';
import { AddAccountComponent } from './views/accounts/add-account/add-account.component';
import { AccountDetailsComponent } from './views/accounts/view-account/account-details/account-details.component';
import { ContactDetailsComponent } from './views/accounts/view-account/contact-details/contact-details.component';
import { ViewAccountComponent } from './views/accounts/view-account/view-account.component';
import { AfxSyncfailedlogComponent } from './views/afx-syncfailedlog/afx-syncfailedlog.component';
import { AfxexceptionComponent } from './views/afxexception/afxexception.component';
import { AddApplicationVersionComponent } from './views/application-version/add-application-version/add-application-version.component';
import { ApplicationVersionComponent } from './views/application-version/application-version.component';
import { EditApplicationVersionComponent } from './views/application-version/edit-application-version/edit-application-version.component';
import { AddAppointmentsComponent } from './views/appointment/add-appointments/add-appointments.component';
import { AddCustomerComponent } from './views/appointment/add-customer/add-customer.component';
import { AppointmentComponent } from './views/appointment/appointment.component';
import { AddAdditionalWorkJobComponent } from './views/appointment/edit-appointment/appointment-additional-work/add-additional-work-job/add-additional-work-job.component';
import { AppointmentAdditionalWorkComponent } from './views/appointment/edit-appointment/appointment-additional-work/appointment-additional-work.component';
import { WOConfirmationComponent } from './views/appointment/edit-appointment/appointment-additional-work/wo-confirmation/wo-confirmation.component';
import { AppointmentCommunicationComponent } from './views/appointment/edit-appointment/appointment-communication/appointment-communication.component';
import { AppointmentDWOComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/appointment-dwo.component';
import { DwoChecklistComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-checklist/dwo-checklist/dwo-checklist.component';
import { DwoCommentsComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-comments/dwo-comments/dwo-comments.component';
import { DwoDiagnoseDetailsComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-diagnose/dwo-diagnose-details/dwo-diagnose-details/dwo-diagnose-details.component';
import { DwoDiagnoseComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-diagnose/dwo-diagnose/dwo-diagnose.component';
import { DwoDocumentsComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-documents/dwo-documents/dwo-documents.component';
import { MechanicCommentsComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-mechanic-comments/mechanic-comments/mechanic-comments.component';
import { AppointmentParkingComponent } from './views/appointment/edit-appointment/appointment-parking/appointment-parking/appointment-parking.component';
import { AddBookingComponent } from './views/appointment/edit-appointment/appointment-planning/add-booking/add-booking.component';
import { AppointmentPlanningComponent } from './views/appointment/edit-appointment/appointment-planning/appointment-planning.component';
import { AppointmentSlotDetailComponent } from './views/appointment/edit-appointment/appointment-planning/appointment-slot-detail/appointment-slot-detail/appointment-slot-detail.component';
import { AppointmentUpdateComponent } from './views/appointment/edit-appointment/appointment-update/appointment-update.component';
import { ActiveWorkOrdersComponent } from './views/appointment/edit-appointment/appointment-work-order-history/active-work-orders/active-work-orders.component';
import { AppointmentWorkOrderHistoryComponent } from './views/appointment/edit-appointment/appointment-work-order-history/appointment-work-order-history.component';
import { HistoricalWorkOrdersComponent } from './views/appointment/edit-appointment/appointment-work-order-history/historical-work-orders/historical-work-orders.component';
import { WorkOrderHistoryDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order-history/work-order-history-details/work-order-history-details.component';
import { AppointmentWorkOrderComponent } from './views/appointment/edit-appointment/appointment-work-order/appointment-work-order.component';
import { WorkOrderAppointmentDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-appointment-details/work-order-appointment-details.component';
import { WorkOrderContactDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-contact-details/work-order-contact-details.component';
import { WorkOrderCustomerDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-customer-details/work-order-customer-details.component';
import { WorkOrderServicesComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-services/work-order-services.component';
import { WorkOrderVehicleDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-vehicle-details/work-order-vehicle-details.component';
import { EditAppointmentComponent } from './views/appointment/edit-appointment/edit-appointment.component';
import { PDFAppointmentOrderComponent } from './views/appointment/edit-appointment/pdf-appointment-order/pdf-appointment-order.component';
import { PDFViewComponent } from './views/appointment/edit-appointment/pdf-appointment-order/pdf-view/pdf-view.component';
import { AddRecipientComponent } from './views/appointment/edit-appointment/send-notification/add-recipient/add-recipient.component';
import { MyRecipientComponent } from './views/appointment/edit-appointment/send-notification/my-recipient/my-recipient.component';
import { SendNotificationComponent } from './views/appointment/edit-appointment/send-notification/send-notification.component';
import { TecRmiPartDetailComponent } from './views/appointment/edit-appointment/tec-rmi-popup/tec-rmi-part-detail/tec-rmi-part-detail.component';
import { TecRmiPopupComponent } from './views/appointment/edit-appointment/tec-rmi-popup/tec-rmi-popup.component';
import { AddAutoKeyComponent } from './views/auto-key/auto-key/add-auto-key/add-auto-key/add-auto-key.component';
import { WithWorkOrderComponent } from './views/auto-key/auto-key/add-auto-key/add-auto-key/with-work-order/with-work-order.component';
import { WithoutWorkOrderComponent } from './views/auto-key/auto-key/add-auto-key/add-auto-key/without-work-order/without-work-order.component';
import { AutoKeyComponent } from './views/auto-key/auto-key/auto-key.component';
import { ViewAutoKeyComponent } from './views/auto-key/auto-key/view-auto-key/view-auto-key/view-auto-key.component';
import { AddBrandComponent } from './views/brand/add-brand/add-brand/add-brand.component';
import { BrandComponent } from './views/brand/brand/brand.component';
import { EditBrandComponent } from './views/brand/edit-brand/edit-brand/edit-brand.component';
import { AddCampaignCustomerComponent } from './views/campaign-management/campaign/add-campaign-customer/add-campaign-customer.component';
import { CampaignComponent } from './views/campaign-management/campaign/campaign.component';
import { EditCampaignComponent } from './views/campaign-management/campaign/edit-campaign/edit-campaign.component';
import { EditCampaignTemplateComponent } from './views/campaign-management/campaign-template/edit-campaign-template/edit-campaign-template.component';
import { EditTargetedGroupComponent } from './views/campaign-management/targeted-group/edit-targeted-group/edit-targeted-group.component';
import { EmailTemplateModelComponent } from './views/campaign-management/campaign/email-template-model/email-template-model.component';
import { CampaignTemplateComponent } from './views/campaign-management/campaign-template/campaign-template.component';
import { TargetedGroupComponent } from './views/campaign-management/targeted-group/targeted-group.component';
import { AddCheckListItemsComponent } from './views/check-list-management/add-check-list-items/add-check-list-items.component';
import { AddCheckListComponent } from './views/check-list-management/add-check-list/add-check-list.component';
import { CheckListManagementComponent } from './views/check-list-management/check-list-management.component';
import { AddCompetenceComponent } from './views/competence/add-competence/add-competence.component';
import { CompetenceComponent } from './views/competence/competence/competence.component';
import { EditCompetenceComponent } from './views/competence/edit-competence/edit-competence.component';
import { CustomerComponent } from './views/customer/customer.component';
import { CustomerCommunicationComponent } from './views/customer/view-customer/customer-communication/customer-communication.component';
import { CustomerCallHistoryComponent } from './views/customer/view-customer/customer-call-history/customer-call-history.component';
import { CustomerDetailsComponent } from './views/customer/view-customer/customer-details/customer-details.component';
import { MultiCustomerListComponent } from './views/customer/view-customer/customer-details/multi-customer-list/multi-customer-list.component';
import { VehicleListComponent } from './views/customer/view-customer/vehicle-list/vehicle-list.component';
import { VehiclesComponent } from './views/customer/view-customer/vehicles/vehicles.component';
import { ViewCustomerComponent } from './views/customer/view-customer/view-customer.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { LicenseKeyValidationComponent } from './views/dashboard/license-key-validation/license-key-validation.component';
import { AddDealerHolidayComponent } from './views/dealer-holiday/add-dealer-holiday/add-dealer-holiday.component';
import { DealerHolidayComponent } from './views/dealer-holiday/dealer-holiday.component';
import { EditDealerHolidayComponent } from './views/dealer-holiday/edit-dealer-holiday/edit-dealer-holiday.component';
import { AddDealerKeydropLocationComponent } from './views/dealer-keydrop-location/add-dealer-keydrop-location/add-dealer-keydrop-location.component';
import { DealerKeydropLocationComponent } from './views/dealer-keydrop-location/dealer-keydrop-location.component';
import { EditDealerKeydropLocationComponent } from './views/dealer-keydrop-location/edit-dealer-keydrop-location/edit-dealer-keydrop-location.component';
import { DealerParkingComponent } from './views/dealer-parking/dealer-parking/dealer-parking.component';
import { AddDealerPartsComponent } from './views/dealer-parts/add-dealer-parts/add-dealer-parts.component';
import { DealerPartsComponent } from './views/dealer-parts/dealer-parts.component';
import { EditDealerPartsComponent } from './views/dealer-parts/edit-dealer-parts/edit-dealer-parts.component';
import { AddDealerServiceComponent } from './views/dealer-service/add-dealer-service/add-dealer-service.component';
import { DealerServiceComponent } from './views/dealer-service/dealer-service.component';
import { EditDealerServiceComponent } from './views/dealer-service/edit-dealer-service/edit-dealer-service.component';
import { AddDealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/add-dealer-special-too/add-dealer-special-tool/add-dealer-special-tool.component';
import { DealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/dealer-special-tool.component';
import { EditDealerSpecialToolComponent } from './views/dealer-special-tool/dealer-special-tool/edit-dealer-special-tool/edit-dealer-special-tool/edit-dealer-special-tool.component';
import { AddDealerComponent } from './views/dealer/add-dealer/add-dealer.component';
import { GetDmsDealerComponent } from './views/dealer/get-dms-dealer/get-dms-dealer.component';
import { DealerComponent } from './views/dealer/dealer.component';
import { EditDealerWorkingHoursComponent } from './views/dealer/edit-dealer/edit-dealer-working-hours/edit-dealer-working-hours.component';
import { EditDealerComponent } from './views/dealer/edit-dealer/edit-dealer.component';
import { EditTaxDetailsComponent } from './views/dealer/edit-dealer/edit-tax-details/edit-tax-details.component';
import { AddDiagnoseCheckListItemsComponent } from './views/diagnose-check-list/diagnose-check-list/add-diagnose-check-list-items/add-diagnose-check-list-items.component';
import { AddDiagnoseCheckListComponent } from './views/diagnose-check-list/diagnose-check-list/add-diagnose-check-list/add-diagnose-check-list/add-diagnose-check-list.component';
import { DiagnoseCheckListComponent } from './views/diagnose-check-list/diagnose-check-list/diagnose-check-list.component';
import { AddDiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/add-diagnose-template/add-diagnose-template/add-diagnose-template.component';
import { DiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/diagnose-template.component';
import { EditDiagnoseTemplateComponent } from './views/diagnose-template/diagnose-template/edit-diagnose-template/edit-diagnose-template/edit-diagnose-template.component';
import { AddDmsValuesComponent } from './views/dms-defaultvalues/add-dms-values/add-dms-values.component';
import { DmsValuesComponent } from './views/dms-defaultvalues/dms-values/dms-values.component';
import { DmsSyncfailedlogComponent } from './views/dms-syncfailedlog/dms-syncfailedlog.component';
import { ExceptionViewComponent } from './views/exception-view/exception-view.component';
import { FeatureComponent } from './views/feature/feature.component';
import { CallerInfoComponent } from './views/header/caller-info/caller-info.component';
import { HeaderComponent } from './views/header/header.component';
import { AddEditLaborComponent } from './views/labor/add-edit-labor/add-edit-labor.component';
import { LaborComponent } from './views/labor/labor.component';
import { SearchLaborComponent } from './views/labor/search-labor/search-labor.component';
import { LogofSmsEmailSentComponent } from './views/logof-sms-email-sent/logof-sms-email-sent.component';
import { MapAppointmentStatusComponent } from './views/map-appointment-status/map-appointment-status.component';
import { AddMechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/add-mechanic-time-code/add-mechanic-time-code/add-mechanic-time-code.component';
import { EditMechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/edit-mechanic-time-code/edit-mechanic-time-code/edit-mechanic-time-code.component';
import { MechanicTimeCodeComponent } from './views/mechanic-time-code/mechanic-time-code/mechanic-time-code.component';
import { AddMechanicComponent } from './views/mechanic/add-mechanic/add-mechanic.component';
import { EditBasicDetailsMechanicComponent } from './views/mechanic/edit-basic-details-mechanic/edit-basic-details-mechanic.component';
import { EditCompetenceMechanicComponent } from './views/mechanic/edit-competence-mechanic/edit-competence-mechanic.component';
import { MultiselectorDropdownBrandComponent } from './views/mechanic/edit-competence-mechanic/multiselector-dropdown-brand/multiselector-dropdown-brand.component';
import { MultiselectorDropdownVehicleTypeComponent } from './views/mechanic/edit-competence-mechanic/multiselector-dropdown-vehicle-type/multiselector-dropdown-vehicle-type.component';
import { EditHoursMechanicComponent } from './views/mechanic/edit-hours-mechanic/edit-hours-mechanic.component';
import { EditCustomerWaitingHoursMechanicComponent } from './views/mechanic/edit-customer-waiting-hours-mechanic/edit-customer-waiting-hours-mechanic.component';
import { EditLeavesMechanicComponent } from './views/mechanic/mechanic-leave/edit-leaves-mechanic/edit-leaves-mechanic.component';
import { EditMechanicComponent } from './views/mechanic/edit-mechanic/edit-mechanic.component';
import { MechanicRecipientListComponent } from './views/mechanic/mechanic-recipient-list/mechanic-recipient-list.component';
import { MechanicComponent } from './views/mechanic/mechanic.component';
import { MenuComponent } from './views/menu/menu.component';
import { ReleaseNotesComponent } from './views/menu/release-note/release-notes/release-notes.component';
import { NotificationDetailsComponent } from './views/notification-details/notification-details.component';
import { ViewAllNotificationsComponent } from './views/notification-details/view-all-notifications/view-all-notifications.component';
import { AddPackageComponent } from './views/package/add-package/add-package.component';
import { PackageComponent } from './views/package/package.component';
import { SearchPackageComponent } from './views/package/search-package/search-package.component';
import { AddPartsComponent } from './views/parts/add-parts/add-parts.component';
import { EditPartsComponent } from './views/parts/edit-parts/edit-parts.component';
import { PartsComponent } from './views/parts/parts/parts.component';
import { SearchPartsComponent } from './views/parts/search-parts/search-parts.component';
import { SearchReplacementPartsComponent } from './views/parts/search-parts/search-replacement-parts/search-replacement-parts.component';
import { PlanningComponent } from './views/planning/planning.component';
import { AddReceptionComponent } from './views/reception/add-reception/add-reception.component';
import { EditReceptionComponent } from './views/reception/edit-reception/edit-reception.component';
import { ReceptionComponent } from './views/reception/reception.component';
import { AddRentalCarComponent } from './views/Rental-Car/add-rental-car/add-rental-car.component';
import { EditRentalCarComponent } from './views/Rental-Car/edit-rental-car/edit-rental-car.component';
import { RentalCarComponent } from './views/Rental-Car/rental-car.component';
import { CustomerDropComponent } from './views/report/customer-drop/customer-drop.component';
import { CustomerWaitingComponent } from './views/report/customer-waiting/customer-waiting.component';
import { MechanicClockingTimeComponent } from './views/report/mechanic-clocking-time/mechanic-clocking-time.component';
import { PickupDropoffComponent } from './views/report/pickup-dropoff/pickup-dropoff.component';
import { CallDealerLogsComponent } from './views/report/call-dealer-logs/call-dealer-logs.component';
import { EditRolesRightsComponent } from './views/roles-rights/edit-roles-rights/edit-roles-rights.component';
import { RolesRightsComponent } from './views/roles-rights/roles-rights.component';
import { AddServiceCategoryComponent } from './views/service-category/add-service-category/add-service-category/add-service-category.component';
import { EditServiceCategoryComponent } from './views/service-category/edit-service-category/edit-service-category/edit-service-category.component';
import { ServiceCategoryComponent } from './views/service-category/service-category.component';
import { AddServiceComponent } from './views/services/add-service/add-service.component';
import { EditServiceComponent } from './views/services/edit-service/edit-service.component';
import { SearchServiceComponent } from './views/services/search-service/search-service.component';
import { ServicesComponent } from './views/services/services.component';
import { AddSpecialToolComponent } from './views/special-tool/add-special-tool/add-special-tool/add-special-tool.component';
import { EditSpecialToolComponent } from './views/special-tool/edit-special-tool/edit-special-tool/edit-special-tool.component';
import { SpecialToolComponent } from './views/special-tool/special-tool/special-tool.component';
import { StatusConfigurationComponent } from './views/status-configuration/status-configuration.component';
import { SyncJobsComponent } from './views/sync-jobs/sync-jobs.component';
import { AddTechnicalManualComponent } from './views/technical-manual/technical-manual/add-technical-manual/add-technical-manual/add-technical-manual.component';
import { TechnicalManualComponent } from './views/technical-manual/technical-manual/technical-manual.component';
import { ViewTechnicalManualComponent } from './views/technical-manual/technical-manual/view-technical-manual/view-technical-manual/view-technical-manual.component';
import { AddTemplateComponent } from './views/template/add-template/add-template.component';
import { EditTemplateComponent } from './views/template/edit-template/edit-template.component';
import { TemplateComponent } from './views/template/template.component';
import { TimeStampComponent } from './views/time-stamp/time-stamp.component';
import { AddVehicleComponent } from './views/vehicle/add-vehicle/add-vehicle.component';
import { CustomerDetailComponent } from './views/vehicle/edit-vehicle/customer-detail/customer-detail.component';
import { EditVehicleComponent } from './views/vehicle/edit-vehicle/edit-vehicle.component';
import { VehicleOwnershipHistoryComponent } from './views/vehicle/edit-vehicle/vehicle-ownership-history/vehicle-ownership-history.component';
import { VehicleManagementComponent } from './views/vehicle/vehicle-management.component';
import { CustomerValidationComponent } from './views/widget-appointment-request/customer-validation/customer-validation.component';
import { EditWidgetAppointmentComponent } from './views/widget-appointment-request/edit-widget-appointment/edit-widget-appointment.component';
import { WidgetAppointmentRequestComponent } from './views/widget-appointment-request/widget-appointment-request.component';
import { ContactUserComponent } from './views/report/contact-user/contact-user.component';
import { CheckinUserComponent } from './views/report/checkin-user/checkin-user.component';
import { CheckinDealerDetailsComponent } from './views/report/checkin-user/checkin-dealer-details/checkin-dealer-details.component';
import { NotificationViewComponent } from './views/notification-details/notification-view/notification-view.component';
import { OnholdStatusChangeComponent } from './components/onhold-status-change/onhold-status-change.component';
import { AppointmentLockingComponent } from './views/appointment-locking/appointment-locking.component';
import { AppointmentDocumentComponent } from './views/appointment/edit-appointment/appointment-document/appointment-document.component';
import { SearchAlternatePartsComponent } from './views/parts/search-parts/search-alternate-parts/search-alternate-parts.component';
import { AddMulticplourChecklistItemComponent } from './views/check-list-management/add-multicplour-checklist-item/add-multicplour-checklist-item.component';
import { DmsSyncschedulerlogComponent } from './views/dms-syncschedulerlog/dms-syncschedulerlog.component';
import { DmsQueueexceptionComponent } from './views/dms-queueexception/dms-queueexception.component';
import { StringtoshareboxdetailsPipe } from './pipe/stringtoshareboxdetails.pipe';
import { MechanicEfficiencyReportComponent } from './views/report/mechanic-efficiency-report/mechanic-efficiency-report.component';
import { MechanicReportComponent } from './views/report/mechanic-report/mechanic-report.component';
import { ServiceMechanicWiseReportComponent } from './views/report/service-mechanic-wise-report/service-mechanic-wise-report.component';
import { PreferencesComponent } from './views/preferences/preferences.component';
import { AddPreferencesComponent } from './views/preferences/add-preferences/add-preferences.component';
import { EditPreferencesComponent } from './views/preferences/edit-preferences/edit-preferences.component';
import { PromotionsComponent } from './views/promotions/promotions.component';
import { AddPromotionsComponent } from './views/promotions/add-promotions/add-promotions.component';
import { EditPromotionsComponent } from './views/promotions/edit-promotions/edit-promotions.component';
import { CategoryComponent } from './views/category/category.component';
import { AddCategoryComponent } from './views/category/add-category/add-category.component';
import { EditCategoryComponent } from './views/category/edit-category/edit-category.component';

import { TecRmiLabourPopupComponent } from './views/appointment/edit-appointment/tec-rmi-labour-popup/tec-rmi-labour-popup.component';
import { ArchivedAppointmentComponent } from './views/archived-appointment/archived-appointment.component';
import { DeletedVehiclesComponent } from './views/deleted-vehicles/deleted-vehicles.component';
import { DeletedCustomerComponent } from './views/deleted-customer/deleted-customer.component';
import { WarningLightComponent } from './views/warning-light/warning-light.component';
import { AddEditWarningLightComponent } from './views/warning-light/add-edit-warning-light/add-edit-warning-light.component';
import { ActionTypeComponent } from './views/action-type/action-type.component';
import { AutomaticUpdatesComponent } from './views/automatic-updates/automatic-updates.component';
import { AddRolesRightsComponent } from './views/roles-rights/add-roles-rights/add-roles-rights.component';
import { StringtodemandcommentPipe } from './pipe/stringtodemandcomment.pipe';
import { DealerWiseAgentListComponent } from './views/report/agent-efficiency/dealer-wise-agent-list/dealer-wise-agent-list.component';
import { AgentsDetailsListComponent } from './views/report/agent-efficiency/agents-details-list/agents-details-list.component';
import { CheckInTraversalLogComponent } from './views/report/checkin-user/checkin-traversal-log/check-in-traversal-log/check-in-traversal-log.component';
import { TemplateFieldHelpComponent } from './views/template/template-field-help/template-field-help.component';
import { DeletedPlanningComponent } from './views/report/deleted-planning/deleted-planning.component';
import { CustomerSendNotificationComponent } from './views/customer/view-customer/customer-send-notification/customer-send-notification.component';
import { DealerWiseCallHistoryComponent } from './views/report/call-dealer-logs/dealer-wise-call-history/dealer-wise-call-history.component';
import { UserViseAppointmentComponent } from './views/report/user-vise-appointment/user-vise-appointment.component';
import { MultiStackPopupService } from './services/multi-stack-popup.service';
import { DeleteWorkorderComponent } from './components/delete-workorder/delete-workorder.component';
import { CancelStatusChangeComponent } from './components/cancel-status-change/cancel-status-change.component';
import { MechanicClockinComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/mechanic-clockin/mechanic-clockin.component'
import { CdssAppointmentComponent } from './views/report/cdss-appointment/cdss-appointment.component';
import { StringToNumberPipe } from './pipe/StringToNumberPipe.pipe';
import { WhatsAppMessagesComponent } from './views/appointment/whatsapp-messages/whatsapp-messages.component';
import { WorkOrderGeneralInfoComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-general-info/work-order-general-info.component';
import { BnhAppointmentGeneralInformationComponent } from './views/appointment/edit-appointment/appointment-work-order/bnh-appointment-general-information/bnh-appointment-general-information.component';
import { BnhWorkOderAppointmentDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/bnh-work-oder-appointment-details/bnh-work-oder-appointment-details.component'
import { StringtotimestampdetailsPipe } from './pipe/stringtotimestampdetails.pipe';
import { AppointmentInvoiceComponent } from './views/appointment/edit-appointment/appointment-invoice/appointment-invoice.component';
import { InvoiceWarningPopupComponent } from './views/appointment/edit-appointment/invoice-warning-popup/invoice-warning-popup.component';
import { TimeStampReportComponent } from './views/report/time-stamp-report/time-stamp-report.component';
import { TimeStampDetailsGridComponent } from './views/report/time-stamp-report/time-stamp-details-grid/time-stamp-details-grid.component';
import { PartSalesPriceCalculationComponent } from './views/part-calculation/part-sales-price-calculation/part-sales-price-calculation.component';
import { LaborChargingGroupPriceComponent } from './views/labor/labor-charging-group/labor-charging-group-price/labor-charging-group-price.component';
import { CustomerDealerAssociationComponent } from './views/customer/view-customer/customer-dealer-association/customer-dealer-association.component';
import { SstChecklistComponent } from './views/appointment/edit-appointment/appointment-DWO/appointment-dwo/dwo-diagnose/sst-checklist/sst-checklist.component';
import { WorkOrderGiftCardDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/work-order-gift-card-details/work-order-gift-card-details.component';
import { MgAppointmentGeneralInformationComponent } from './views/appointment/edit-appointment/appointment-work-order/mg-appointment-general-information/mg-appointment-general-information.component';
import { MgWorkOderAppointmentDetailsComponent } from './views/appointment/edit-appointment/appointment-work-order/mg-work-oder-appointment-details/mg-work-oder-appointment-details.component';
import { CustomerHistoryComponent } from './views/customer/view-customer/customer-history/customer-history.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TotalSoldHoursReportComponent } from './views/report/total-sold-hours-report/total-sold-hours-report.component';
import { TotalSoldHoursDetailsGridComponent } from './views/report/total-sold-hours-report/total-sold-hours-details-grid/total-sold-hours-details-grid.component';
import { AfDirectiveModule } from 'projects/Autofacets-Core/src/app/directives/af-directive-core.module';
import { NgChartsModule } from 'ng2-charts';
import { ExceptionLogComponent } from './views/exception-log/exception-log.component';
import { ExceptionLogListComponent } from './views/exception-log-list/exception-log-list.component';
import { EditUserShiftComponent } from './views/reception/edit-user-shift/edit-user-shift.component';
import { UserLeaveComponent } from './views/reception/user-leave/user-leave.component';
import { UserClockInOutComponent } from './views/user-clock-in-out/user-clock-in-out.component';
import { AddUserClockInOutComponent } from './views/user-clock-in-out/add-user-clock-in-out/add-user-clock-in-out.component';
import { UserStampReportComponent } from './views/user-stamp-report/user-stamp-report.component';
import { ShareboxLogComponent } from './views/appointment/edit-appointment/sharebox-log/sharebox-log.component';
import { BlockMechanicComponent } from './components/block-mechanic/block-mechanic.component';
import { WorkOrderStatusComponent } from './views/report/work-order-status/work-order-status.component';
import { TowedInReportComponent } from './views/report/towed-in-report/towed-in-report.component';
import { TowedinDealerDetailsComponent } from './views/report/towed-in-report/towedin-dealer-details/towedin-dealer-details.component';
import { WeekPlanningSlotDetailComponent } from './views/planning/week-planning-slot-detail/week-planning-slot-detail.component';
import { AdditionalWorkReportComponent } from './views/report/additional-work-report/additional-work-report.component';
import { WidgetAppointmentReportComponent } from './views/report/widget-appointment-report/widget-appointment-report.component';
import { ErrorLogAnalysisReportComponent } from './views/report/error-log-analysis-report/error-log-analysis-report.component';
import { ErrorLogEndpointDetailsComponent } from './views/report/error-log-analysis-report/error-log-endpoint-details/error-log-endpoint-details.component';
import { ErrorLogOccurrenceListComponent } from './views/report/error-log-analysis-report/error-log-occurrence-list/error-log-occurrence-list.component';
import { ErrorLogStatusEditorComponent } from './views/report/error-log-analysis-report/error-log-status-editor/error-log-status-editor.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { WorkorderTimeStampReportComponent } from './views/report/workorder-time-stamp-report/workorder-time-stamp-report.component';
import { SyncFailAppointmentComponent } from './views/appointment/sync-fail-appointment/sync-fail-appointment.component';
import { CustomerUpdatePipe } from './pipe/stringtotablechanges.pipe';
import { OAuthErrorInterceptor } from 'projects/Autofacets-Core/src/app/interceptor/oauth-error.interceptor';
import { AutofocusDirective } from './directives/autofocus.directive';
import { QuillPreserveHtmlDirective } from './directives/quill-preserve-html.directive';
import { EditDealerCustomerWaitingHoursComponent } from './views/dealer/edit-dealer/edit-dealer-customer-waiting-hours/edit-dealer-customer-waiting-hours.component';
import { ServiceResourceAssignmentModalComponent } from './components/service-resource-assignment/service-resource-assignment-modal.component';
@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}

export function createTranslateLoader(commonLocalizationService: LanguageDataService) {
  return new CustomLoader(commonLocalizationService);
}
// checks if the app is running on IE
export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(_logLevel: LogLevel, _message: string) {
  // set for loggerCallback
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientID,
      authority: environment.msalConfig.authority,
      redirectUri: environment.msalConfig.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: environment.msalConfig.cacheLocation as BrowserCacheLocation,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  if (environment.currentenvironment == 'bnh') {
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [environment.msalConfig.protectedResourceMap, [...environment.msalConfig.consentScopes]]
      ])
    }
  }
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [environment.msalConfig.protectedResourceMap, [...environment.msalConfig.consentScopes]],
      [environment.parts_service_url, [...environment.msalConfig.consentScopes]]
    ])
  }
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect, authRequest: {
      scopes: [...environment.msalConfig.consentScopes]
    }
  };
}

@NgModule({
  declarations: [
    CurrencySpacePipe,
    ToNumberPipe,
    FileSizePipe,
    SafePipe,
    WorkItemLinkPipe,
    AppComponent,
    ServiceCategoryComponent,
    ServicesComponent,
    AddServiceComponent,
    EditServiceComponent,
    EditServiceCategoryComponent,
    AddServiceCategoryComponent,
    DealerServiceComponent,
    AddDealerServiceComponent,
    EditDealerServiceComponent,
    VehicleManagementComponent,
    EditVehicleComponent,
    DealerComponent,
    DwoCommentsComponent,
    AddDealerComponent,
    GetDmsDealerComponent,
    EditDealerComponent,
    DealerHolidayComponent,
    EditDealerHolidayComponent,
    AddDealerHolidayComponent,
    EditDealerComponent,
    AddRentalCarComponent,
    RentalCarComponent,
    EditRentalCarComponent,
    HeaderComponent,
    CallerInfoComponent,
    MenuComponent,
    NgbdModalContent,
    CheckListManagementComponent,
    AppointmentComponent,
    ArchivedAppointmentComponent,
    MechanicComponent,
    AddMechanicComponent,
    TechnicalManualComponent,
    AddTechnicalManualComponent,
    ViewTechnicalManualComponent,
    SpecialToolComponent,
    AddSpecialToolComponent,
    EditSpecialToolComponent,
    DealerSpecialToolComponent,
    EditDealerSpecialToolComponent,
    EditMechanicComponent,
    AddDealerSpecialToolComponent,
    CheckListManagementComponent,
    AddCheckListComponent,
    AddCheckListItemsComponent,
    AddCheckListItemsComponent,
    DiagnoseCheckListComponent,
    AddDiagnoseCheckListComponent,
    AddDiagnoseCheckListItemsComponent,
    EditDealerWorkingHoursComponent,
    EditDealerCustomerWaitingHoursComponent,
    MechanicTimeCodeComponent,
    AddMechanicTimeCodeComponent,
    AddPartsComponent,
    PartsComponent,
    EditMechanicTimeCodeComponent,
    DiagnoseTemplateComponent,
    AddDiagnoseTemplateComponent,
    EditDiagnoseTemplateComponent,
    AddPartsComponent,
    PartsComponent,
    TemplateComponent,
    AddTemplateComponent,
    EditTemplateComponent,
    EditPartsComponent,
    DealerParkingComponent,
    EditAppointmentComponent,
    AppointmentPlanningComponent,
    AddBookingComponent,
    AppointmentDWOComponent,
    DwoChecklistComponent,
    DwoDocumentsComponent,
    SchedulerListComponent,
    DealerPartsComponent,
    AddDealerPartsComponent,
    AddDiagnoseCheckListItemsComponent,
    EditHoursMechanicComponent,
    EditCustomerWaitingHoursMechanicComponent,
    EditBasicDetailsMechanicComponent,
    EditLeavesMechanicComponent,
    NotificationDetailsComponent, MechanicRecipientListComponent, DealerKeydropLocationComponent, AddDealerKeydropLocationComponent, EditDealerKeydropLocationComponent,
    AddCustomerComponent,
    EditLeavesMechanicComponent,
    NotificationDetailsComponent,
    MechanicRecipientListComponent,
    DealerKeydropLocationComponent,
    AddDealerKeydropLocationComponent,
    EditDealerKeydropLocationComponent,
    EditDealerPartsComponent,
    SchedulerDayViewComponent,
    MechanicSlotFilterPipe,
    StringToPlanningTablePipe,
    UpdateAppointmentHistoryPipe,
    StringToJobDetailsTablePipe,
    StringToTablePipe,
    EditDealerPartsComponent,
    MechanicCommentsComponent,
    AppointmentCommunicationComponent,
    TimeStampComponent,
    AppointmentParkingComponent,
    TimeStampComponent,
    EditTaxDetailsComponent,
    CurrencySpacePipe,
    DwoDiagnoseComponent,
    DwoDiagnoseDetailsComponent,
    DealerSearchboxComponent,
    AppointmentWorkOrderComponent,
    WorkOrderContactDetailsComponent,
    WorkOrderVehicleDetailsComponent,
    WorkOrderServicesComponent,
    AutoKeyComponent,
    ViewAutoKeyComponent,
    AddAutoKeyComponent,
    DashboardComponent,
    StatusConfigurationComponent,
    CustomerComponent,
    ViewCustomerComponent,
    CustomerDetailsComponent,
    CustomerCommunicationComponent,
    CustomerCallHistoryComponent,
    VehicleListComponent,
    RolesRightsComponent,
    EditRolesRightsComponent,
    VehiclesComponent,
    PDFAppointmentOrderComponent,
    PDFViewComponent,
    AppointmentSlotDetailComponent,
    BrandComponent,
    AddBrandComponent,
    EditBrandComponent,
    CompetenceComponent,
    AddCompetenceComponent,
    EditCompetenceComponent,
    EditCompetenceMechanicComponent,
    MultiselectorDropdownBrandComponent,
    MultiselectorDropdownVehicleTypeComponent,
    EditBrandComponent,
    PackageComponent,
    AddPackageComponent,
    LogofSmsEmailSentComponent,
    AddAppointmentsComponent,
    FeatureComponent,
    ReceptionComponent,
    AddReceptionComponent,
    EditReceptionComponent,
    MapAppointmentStatusComponent,
    AppointmentAdditionalWorkComponent,
    AddAdditionalWorkJobComponent,
    WOConfirmationComponent,
    DealerSearchboxDropdownComponent,
    PlanningComponent,
    SendNotificationComponent,
    AddRecipientComponent,
    MyRecipientComponent,
    ServiceAdvisorComponent,
    CampaignComponent,
    TargetedGroupComponent,
    CampaignTemplateComponent,
    EditCampaignComponent,
    EditTargetedGroupComponent,
    AddCampaignCustomerComponent,
    EmailTemplateModelComponent,
    EditCampaignTemplateComponent,
    PaginationComponent,
    AppointmentWorkOrderHistoryComponent,
    ActiveWorkOrdersComponent,
    HistoricalWorkOrdersComponent,
    SyncJobsComponent,
    WorkOrderHistoryDetailsComponent,
    LicenseKeyValidationComponent,
    WorkOrderAppointmentDetailsComponent,
    DmsValuesComponent,
    AddDmsValuesComponent,
    CustomerDetailComponent,
    DmsSyncfailedlogComponent,
    CustomerDetailComponent,
    AfxSyncfailedlogComponent,
    WidgetAppointmentRequestComponent,
    EditWidgetAppointmentComponent,
    CustomerValidationComponent,
    ExceptionViewComponent,
    CustomerWaitingComponent,
    PickupDropoffComponent,
    CallDealerLogsComponent,
    AfxexceptionComponent,
    MultiCustomerListComponent,
    SavedSearchComponent,
    WorkOrderCustomerDetailsComponent,
    ServiceDurationPriceComponent,
    CustomerDropComponent,
    ApplicationVersionComponent,
    AddApplicationVersionComponent,
    EditApplicationVersionComponent,
    ReleaseNotesComponent,
    WithWorkOrderComponent,
    WithoutWorkOrderComponent,
    SearchPartsComponent,
    AccountsComponent,
    ViewAccountComponent,
    AccountDetailsComponent,
    ContactDetailsComponent,
    MechanicClockingTimeComponent,
    AfMechanicSchedulerListComponent,
    AddAccountComponent,
    TecRmiPopupComponent,
    LaborComponent,
    AddEditLaborComponent,
    SearchServiceComponent,
    SearchLaborComponent,
    SearchPackageComponent,
    VehicleOwnershipHistoryComponent,
    AddVehicleComponent,
    TecRmiPartDetailComponent,
    ViewAllNotificationsComponent,
    ContactUserComponent,
    CheckinUserComponent,
    CheckinDealerDetailsComponent,
    NotificationViewComponent,
    SearchAlternatePartsComponent,
    SearchReplacementPartsComponent,
    OnholdStatusChangeComponent,
    AppointmentLockingComponent,
    AppointmentDocumentComponent,
    AddMulticplourChecklistItemComponent,
    DmsSyncschedulerlogComponent,
    AppointmentUpdateComponent,
    StringtoshareboxdetailsPipe,
    DmsQueueexceptionComponent,
    AppointmentUpdateComponent,
    ActionTypeComponent,
    MechanicEfficiencyReportComponent,
    MechanicReportComponent,
    ServiceMechanicWiseReportComponent,
    PreferencesComponent,
    AddPreferencesComponent,
    EditPreferencesComponent,
    PromotionsComponent,
    AddPromotionsComponent,
    EditPromotionsComponent,
    CategoryComponent,
    AddCategoryComponent,
    EditCategoryComponent,
    TecRmiLabourPopupComponent,
    DeletedVehiclesComponent,
    DeletedCustomerComponent,
    WarningLightComponent,
    AddEditWarningLightComponent,
    AutomaticUpdatesComponent,
    AddRolesRightsComponent,
    StringtodemandcommentPipe,
    DealerWiseAgentListComponent,
    AgentsDetailsListComponent,
    CheckInTraversalLogComponent,
    TemplateFieldHelpComponent,
    DeletedPlanningComponent,
    CustomerSendNotificationComponent,
    DealerWiseCallHistoryComponent,
    UserViseAppointmentComponent,
    DeleteWorkorderComponent,
    CancelStatusChangeComponent,
    MechanicClockinComponent,
    CdssAppointmentComponent,
    StringtotimestampdetailsPipe,
    StringToNumberPipe,
    WorkOrderGeneralInfoComponent,
    BnhAppointmentGeneralInformationComponent,
    BnhWorkOderAppointmentDetailsComponent,
    StringtotimestampdetailsPipe,
    InvoiceWarningPopupComponent,
    AppointmentInvoiceComponent,
    WhatsAppMessagesComponent,
    TimeStampReportComponent,
    TimeStampDetailsGridComponent,
    PartSalesPriceCalculationComponent,
    LaborChargingGroupPriceComponent,
    CustomerDealerAssociationComponent,
    SstChecklistComponent,
    WorkOrderGiftCardDetailsComponent,
    MgAppointmentGeneralInformationComponent,
    MgWorkOderAppointmentDetailsComponent,
    CustomerHistoryComponent,
    TotalSoldHoursReportComponent,
    TotalSoldHoursDetailsGridComponent,
    ExceptionLogComponent,
    ExceptionLogListComponent,
    EditUserShiftComponent,
    UserLeaveComponent,
    ExceptionLogListComponent,
    UserClockInOutComponent,
    AddUserClockInOutComponent,
    UserStampReportComponent,
    ShareboxLogComponent,
    BlockMechanicComponent,
    WorkOrderStatusComponent,
    TowedInReportComponent,
    TowedinDealerDetailsComponent,
    WeekPlanningSlotDetailComponent,
    AdditionalWorkReportComponent,
    WorkorderTimeStampReportComponent,
    SyncFailAppointmentComponent,
    WidgetAppointmentReportComponent,
    ErrorLogAnalysisReportComponent,
    ErrorLogEndpointDetailsComponent,
    ErrorLogOccurrenceListComponent,
    ErrorLogStatusEditorComponent,
    CustomerUpdatePipe,
    AutofocusDirective,
    QuillPreserveHtmlDirective,
    ServiceResourceAssignmentModalComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    NgbNavModule,
    NgxIntlTelInputModule,
    AutofacetsCoreModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    ColorPickerModule,
    NgxAngularQueryBuilderModule,
    InfiniteScrollModule,
    NgMultiSelectDropDownModule.forRoot(),
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: environment.msalConfig.clientID,
        authority: environment.msalConfig.authority,
        redirectUri: environment.msalConfig.redirectUri,
        postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: environment.msalConfig.cacheLocation as BrowserCacheLocation,
        storeAuthStateInCookie: isIE,
      }
    }), {
      interactionType: InteractionType.Redirect
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [environment.msalConfig.protectedResourceMap, [...environment.msalConfig.consentScopes]]
      ])
    }),
    NgSelectModule,
    ResizableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [LanguageDataService]
      }
    }),
    QuillModule.forRoot(),
    NgxChartsModule,
    AfDirectiveModule,
    NgChartsModule,
    BsDatepickerModule.forRoot()
  ],
  providers: [
    DecimalPipe,
    DealerServiceDataService,
    DealerServiceBusinessService,
    DealerBusinessService,
    DealerDataService,
    DealerHolidayDataService,
    DealerHolidayBusinessService,
    DatePipe,
    Title,
    ExcelService,
    NgbActiveModal,
    PaginationService,
    MultiStackPopupService,
    CurrentLanguage,
    AdminCommonService,
    {
      provide: APP_INITIALIZER,
      useFactory: AppIntializer,
      deps: [CultureLocaleService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OAuthErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalGuard,
    MsalService,
    MsalBroadcastService,
    {
      provide: LOCALE_ID,
      deps: [CultureLocaleService],
      useFactory: (CultureLocaleService) => CultureLocaleService.getLocale()
    },
    VehicleDataService,
    VehicleBusinessService,
    StatusconfigurationService,
    StatusconfigurationDataService],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
